export const replaceHosts = (arr) => {
	return { type: 'REPLACE_HOSTS', payload: arr }
};
